import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * ラジオオンアイコン
 */
const RadioOnIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath>
            <rect width="24" height="24" fill="none" />
          </clipPath>
        </defs>
        <g clipPath="url(#a)">
          <path
            d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8Z"
            transform="translate(4 4)"
            fill={CLIENT_SETTINGS.colors.main}
          />
          <g fill="none">
            <path d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12Z" stroke="none" />
            <path
              d="M 12 2 C 6.485979080200195 2 2 6.485979080200195 2 12 C 2 17.51401901245117 6.485979080200195 22 12 22 C 17.51401901245117 22 22 17.51401901245117 22 12 C 22 6.485979080200195 17.51401901245117 2 12 2 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z"
              stroke="none"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default RadioOnIcon
